import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

Vue.use(VueAxios, axios).use(ElementUI)

new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
